import { useTranslation } from "react-i18next";

export interface Options {
  value: string;
  label: string;
}

export const getSelectOptions = () => {
  const { t: translate } = useTranslation();

  const modeOptions: Options[] = [{ value: "Sea", label: translate("sea") }];

  const statusOptions: Options[] = [
    { value: "Booked", label: translate("booked") },
    { value: "Collected from Shipper", label: translate("collectedFromShipper") },
    { value: "Not arrived at Port of Load", label: translate("notArrivedAtPortOfLoad") },
    { value: "Waiting at Port of Load", label: translate("waitingAtPortOfLoad") },
    { value: "Shipped on board", label: translate("shippedOnBoard") },
    { value: "Underway", label: translate("underway") },
    { value: "Underway to a Transhipment Port", label: translate("underwayToATranshipmentPort") },
    { value: "Arrival at Transhipment Port", label: translate("arrivalAtTranshipmentPort") },
    { value: "Waiting at Transhipment Port", label: translate("waitingAtTranshipmentPort") },
    {
      value: "Shipped on board at Transhipment Port",
      label: translate("shippedOnBoardAtTranshipmentPort"),
    },
    { value: "Arrived at Port or Discharge", label: translate("arrivedAtPortOrDischarge") },
    { value: "Waiting at Destination Port", label: translate("waitingAtDestinationPort") },
    { value: "Left the Destination Port", label: translate("leftTheDestinationPort") },
    { value: "Shipment Completed", label: translate("shipmentCompleted") },
  ];

  const viaOptions: Options[] = [
    { value: "email", label: translate("email") },
    { value: "sms", label: translate("sms") },
  ];

  return {
    modeOptions,
    statusOptions,
    viaOptions,
  };
};
